<template lang="pug">
.page 

    a-tabs 
        a-tab-pane(v-for="b in bookNames" :key="b" :tab="b")
            Product(:bookName="b" :isAdmin="isAdmin")
        a-tab-pane(key="admin" tab="管理员" v-if="isAdmin") 
            Admin
        
</template>

<script>
import Admin from './Admin.vue';
import Product from './Product.vue';
export default {
    data() {
        return {
            bookNames: [],
            isAdmin: false,
        }
    },
    mounted() {
        this.getPerms();
    },
    methods: {
        getPerms() {
            this.$api.request('GET', 'hkoption/hkProductPnl/perms').then(res => {
                this.isAdmin = res.data.isAdmin;
                this.bookNames = res.data.bookNames;
            });
        }
    },
    components: {
        Admin,
        Product
    }
}
</script>

<style lang="less" scoped>
.weight-item {

}
</style>